import {ApplicationConfig, provideZonelessChangeDetection} from '@angular/core';
import {provideRouter, withComponentInputBinding, withRouterConfig} from '@angular/router';

import {routes} from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from "@angular/common/http";
import {HttpRequestInterceptor} from "@app/_helpers/http-request.interceptor.service";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZonelessChangeDetection(),
        provideRouter(routes, withComponentInputBinding(), withRouterConfig({onSameUrlNavigation: "reload"})),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        {provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true},
    ]
};
